/* eslint-disable */
import React, { useState, useEffect } from "react";
import * as API from "../../framework/API/api";
import { ENTITYNAME, FILEURL, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { utility } from "../../framework/utility/utilityProvider";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { useTranslation } from "../../locale/useTranslation";
import moment from "moment";
import ToastNotification from "../../components/ToastNotification";

export const MediaActualDurationReport = () => {

    const lang = useTranslation();

    const blankDataItem = { Channel: { SID: 0, FullChannelName: "All" } }
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [gridData, setGridData] = useState([]);
    const [loadingStatus, setLoadingStatus] = useState(lang.no_record_found_error_message);
    const [channels, setChannels] = useState([]);

    useEffect(() => {
        loadcombo();
    }, []);
    const loadcombo = async () => {
        let channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        channelRes.data.unshift({ SID: 0, FullChannelName: "All" });
        setChannels(channelRes.data);
    }
    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    };
    const loadData = async () => {
        setGridData([]);
        setLoadingStatus(lang.data_loading_error_message)

        let payload = {
            channelSID: dataItem.Channel.SID,
            isExport: false
        }

        const res = await API.getMediaActualDurationReport(payload);
        console.log(res);
        if (res.success) {
            if (res.data.length > 0) { setGridData(res.data); }
            else { setGridData([]); setLoadingStatus(lang.no_record_found_error_message); }
        }
        else { setGridData([]); setLoadingStatus(lang.no_record_found_error_message); }
    }
    const downloadExcel = async () => {

        if (gridData.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_record_found_error_message });
            return;
        }
        const payload = {
            channelSID: dataItem.Channel.SID,
            isExport: true
        };
        const res = await API.getMediaActualDurationReport(payload);
        if (res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
        }
        else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    };

    return (<>
        <h1 className="page-title txt-color-bludeDark">
            <i
                className="fa fa-table marlr"
                style={{ fontSize: "20px", color: "GrayText" }}
            ></i>
            <span>{lang.media_actual_duration_report_header}</span>
        </h1>
        <div className="row m-1">
            <div className="col-12">
                <div className="row">
                    <div className="col-4">
                        <label className="form-label">{lang.channel_label}</label>
                        <DropDownList
                            data={channels}
                            textField="FullChannelName"
                            dataItemKey="SID"
                            name="Channel"
                            onChange={onChange}
                            value={dataItem.Channel}
                        />
                    </div>
                    <div className="col mt-4">
                        <ActionButton name={lang.show_button_text} onClick={loadData} />
                        <RoundButton icon='download' onClick={() => downloadExcel()} style={{ marginLeft: '10px' }} title={lang.download_button_tooltip} />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12">
                        <Grid data={gridData} style={{ height: '68vh' }} resizable={true}>
                            <GridNoRecords>{loadingStatus}</GridNoRecords>
                            <Column field="MediaId" title={lang.asset_id_column} />
                            <Column field="ProgramTitle" title={lang.program_title_column} />
                            <Column field="ChannelName" title={lang.channel_column} />
                            <Column field="ProgramEpisodeSeason" title={lang.program_episode_season_column} />
                            <Column field="ProgramEpisodeNumber" title={lang.program_episode_number_column} />
                            <Column field="ActualDuration" title={lang.actual_duration_column} />
                            <Column field="SegmentNumber" title={lang.segment_number_column} />
                        </Grid>
                        <div style={{ marginTop: "6px", fontWeight: "600", textAlign: "right", backgroundColor: "black", color: "white", padding: "6px 8px", borderRadius: "4px" }}>
                            Total Count : {gridData?.length}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default MediaActualDurationReport;